export default "__VITE_ASSET__ac7d9f6c__"